module.exports = __webpack_public_path__ + "img/left.303f10c1.svg";